import { render, staticRenderFns } from "./company-modal.vue?vue&type=template&id=57d915e7&"
import script from "./company-modal.vue?vue&type=script&lang=ts&"
export * from "./company-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports